<template>
    <div>
        <div class="row">
            <div class="page-header">
                <div class="d-flex align-items-center">

                    <h2 class="page-header-title">
                        <router-link to="/door-maintenance-reports">
                        Door Maintenance Reports</router-link>
                        &raquo;
                        <router-link :to="{ name: 'door-maintenance-report-view', params: {action: 'view', id: report.site_door_maintenance_report_id} }">
                            {{ report.job_number }} | {{ report.prepared_for }}
                        </router-link>
                        &raquo;
                        <span v-if="isEdit">Edit</span><span v-else>Add</span> Door Set</h2>
                </div>
            </div>
        </div>

        <form @submit.prevent="submit">
            <div class="form-body">
                <div style="display:none;">
                    <div class="col-lg-6 col-md-12"><input type="hidden" name="_method" value="POST"/></div>
                </div>
                <div class="form-body">
                    <div class="row">
                        <div class="col-sm-12 widget-20">
                            <div class="widget has-shadow">
                                <div class="widget-header bordered d-flex align-items-center section-header">
                                    <h2>Door Set Details</h2>
                                </div>
                                <div class="widget-body">
                                    <div class="form-group row d-flex align-items-center ">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('door_identifier')]"
                                                for="door_identifier">
                                            Door ID
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <input
                                                    name="door_identifier"
                                                    id="door_identifier"
                                                    :class="['form-control', getFieldClasses('door_identifier')]"
                                                    v-model="door.door_identifier"
                                                    type="text"
                                                    maxlength="50"
                                                    class="form-control"
                                                    @blur="onFieldBlur('door_identifier')"
                                            />
                                            <div v-if="isErrorField('door_identifier')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center ">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('door_location')]"
                                                for="door_location">
                                            Door Location
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <input
                                                    name="door_location"
                                                    id="door_location"
                                                    :class="['form-control', getFieldClasses('door_location')]"
                                                    v-model="door.door_location"
                                                    type="text"
                                                    maxlength="150"
                                                    class="form-control"
                                                    @blur="onFieldBlur('door_location')"
                                            />
                                            <div v-if="isErrorField('door_location')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('declared_fire_resistance_period')]"
                                                for="declared_fire_resistance_period">
                                            Client Declared Resistance Period
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <select
                                                    name="declared_fire_resistance_period"
                                                    id="declared_fire_resistance_period"
                                                    :class="['form-control', getFieldClasses('declared_fire_resistance_period')]"
                                                    v-model="door.declared_fire_resistance_period"
                                                    @blur="onFieldBlur('declared_fire_resistance_period')"
                                            >
                                                <option value="" disabled="disabled">Please select an option</option>
                                                <option v-bind:value="declaredResistanceLevel.declared_resistance_level_title" v-for="declaredResistanceLevel in declaredResistanceLevels" v-bind:key="declaredResistanceLevel.declared_resistance_level_id">{{ declaredResistanceLevel.declared_resistance_level_title }}</option>
                                            </select>
                                            <div v-if="isErrorField('declared_resistance_level')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center ">
                                        <label v-if="report.use_bm_trada_template"
                                            class="col-lg-4 form-control-label d-flex justify-content-lg-end"
                                            for="arts_carried_out">
                                            ARTs carried out (ART No. and Rev No.)
                                        </label>
                                        <label v-else
                                            class="col-lg-4 form-control-label d-flex justify-content-lg-end"
                                            for="arts_carried_out">
                                            Description of work carried out
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <textarea class="form-control"
                                                v-model="door.arts_carried_out"
                                                name="arts_carried_out"
                                                maxlength="2000"
                                                id="arts_carried_out"
                                                rows="5"></textarea>
                                        </div>
                                    </div>

                                    <div v-if="report.use_bm_trada_template" class="form-group row d-flex align-items-center mb-5 required">
                                        <div class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                            <p>Maintenance Label Fitted</p>
                                        </div>
                                        <div class="col-lg-6 col-md-12">
                                            <ul class="radio-as-buttons">
                                                <li style="width: 45%">
                                                    <input type="radio" :value="true" id="scpf-yes"
                                                        name="maintenance_label_fitted"
                                                        class="button-positive"
                                                        v-model="door.maintenance_label_fitted"
                                                    >
                                                    <label for="scpf-yes">Yes</label>
                                                </li>
                                                <li style="width: 45%">
                                                    <input type="radio" :value="false" id="scpf-no"
                                                        name="maintenance_label_fitted"
                                                        class="button-negative"
                                                        v-model="door.maintenance_label_fitted"
                                                    >
                                                    <label for="scpf-no">No</label>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div v-if="report.use_bm_trada_template" class="form-group row d-flex align-items-center">
                                        <label 
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end']"
                                                for="maintenance_date">
                                            Maintenance Completed Date
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <datepicker
                                                    v-model="door.maintenance_date"
                                                    format="dd/MM/yy"
                                                    input-class="form-control"
                                                    name="maintenance_date"
                                            ></datepicker>
                                        </div>
                                    </div>


                                    <div class="form-group row d-flex align-items-center ">
                                        <label
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end', getContainerClasses('maintained_by')]"
                                                for="maintained_by">
                                            Maintained By
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <input
                                                    name="maintained_by"
                                                    id="maintained_by"
                                                    :class="['form-control', getFieldClasses('maintained_by')]"
                                                    v-model="door.maintained_by"
                                                    type="text"
                                                    maxlength="255"
                                                    class="form-control"
                                                    @blur="onFieldBlur('maintained_by')"
                                            />
                                            <div v-if="isErrorField('maintained_by')" class="invalid-feedback">This field is required</div>
                                        </div>
                                    </div>

                                    
                                    <div v-if="report.use_bm_trada_template" class="form-group row d-flex align-items-center">
                                        <label 
                                                :class="['col-lg-4', 'form-control-label', 'd-flex', 'justify-content-lg-end']"
                                                for="next_maintenance_due_date">
                                            Next Maintenance Due Date
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <datepicker
                                                    v-model="door.next_maintenance_due_date"
                                                    format="dd/MM/yy"
                                                    input-class="form-control"
                                                    name="next_maintenance_due_date"
                                            ></datepicker>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center ">
                                        <label
                                            class="col-lg-4 form-control-label d-flex justify-content-lg-end"
                                            for="comments">
                                            Comments
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <textarea class="form-control"
                                                v-model="door.comments"
                                                name="comments"
                                                maxlength="2000"
                                                id="comments"
                                                rows="5"></textarea>
                                        </div>
                                    </div>

                                    <div class="form-group row d-flex align-items-center">
                                        <label class="col-lg-4 form-control-label d-flex justify-content-lg-end">
                                            Photos
                                        </label>
                                        <div class="col-lg-6 col-md-12">
                                            <div v-for="offlineImage in door.offline_images" style="margin-bottom: 10px;">
                                                <img v-bind:src="offlineImage.data" class="img-fluid">
                                            </div>
                                            <div v-if="isImageUploading" style="background: #eaeaea; padding: 10px; margin: 10px 0;">
                                                <h3><span class="fa fa-spin fa-circle-notch"></span>
                                                    Adding image... Please wait...</h3>
                                            </div>
                                            <label class="fileContainer">
                                                <span class="fa fa-camera"></span> Click to add an image
                                                <input type="file" accept="image/*" capture="camera" @change="onFileChange">
                                            </label>
                                        </div>
                                    </div>

                                    <div class="alert alert-danger" v-if="isError">
                                        <p class="mb-0">
                                            <strong>The following fields have errors or are missing:</strong>
                                        </p>
                                        <ul class="mb-0 pl-3" v-if="errors.length > 0">
                                            <li v-for="error in errors" v-bind:key="error.field">
                                                <span v-if="error.field">{{ 'form.'+error.field }}<span v-if="error.message">: error.message</span></span>
                                                <span v-else-if="error.message">error.message</span>
                                            </li>
                                        </ul>
                                    </div>

                                </div>
                            </div>

                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">

                            <div class="form-group">
                                <button type="submit" class="btn btn-primary btn-square btn-lg w-100" :disabled="submitting">
                                    <span v-if="submitting">Submitting... <i class="fa fa-circle-notch fa-spin"></i></span>
                                    <span v-else>Save</span>
                                </button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </form>



    </div>
</template>


<script>
    import { required } from 'vuelidate/lib/validators';
    import ImageRotate from '@/components/mixins/ImageRotate.js';
    import Datepicker from 'vuejs-datepicker';
    import moment from 'moment';

    var Compress = require('compress.js');
    var EXIF = require('exif-js');

    export default {
        mixins: [ImageRotate],
        data() {
            return {
                isEdit: false,
                isSubmitted: false,
                isError: false,
                errorHeader: 'error.invalidFields',
                errors: [],
                submitting: false,
                isImageUploading: false,
                door: {
                    door_maintenance_report_item_id: null,
                    site_door_maintenance_report_item_id: Math.floor(new Date().getTime() / 1000),
                    site_door_maintenance_report_id: null,
                    door_maintenance_report_id: null,
                    door_identifier: null,
                    door_location: null,
                    declared_fire_resistance_period: null,
                    maintenance_date: null,
                    next_maintenance_due_date: null,
                    maintained_by: null,
                    arts_carried_out: null,
                    maintenance_label_fitted: false,
                    comments: null,
                    door_maintenance_report_item_images: [],
                    offline_images: [],
                },
                report: {
                    door_maintenance_report_id: null,
                    job_number: 'Loading...',
                    prepared_for: 'Please wait...',
                    use_bm_trada_template: false,
                    site_door_maintenance_report_id: this.isEdit ? null : this.$route.params.id,
                },
                declaredResistanceLevels: [],
            }
        },
        validations: {
            door: {
                door_identifier: { required },
                door_location: { required },
                declared_fire_resistance_period: { required }
            },
        },
        components: {
            Datepicker
        },
        methods: {
            onFileChange(e) {
                this.isImageUploading = true;
                var files = e.target.files || e.dataTransfer.files;
                if (!files.length) {
                    this.isImageUploading = false;
                    return;
                }
                var vm = this;
                EXIF.getData(files[0], function() {
                    var orientation = EXIF.getTag(this, "Orientation");
                    vm.createImage(files[0], orientation);
                });
            },
            createImage(file, orientation) {
                var compress = new Compress();
                var files = [file];

                compress.compress(files, {
                    size: 4, // the max size in MB, defaults to 2MB
                    quality: .6, // the quality of the image, max is 1,
                    maxWidth: 700, // the max width of the output image, defaults to 1920px
                    maxHeight: 700, // the max height of the output image, defaults to 1920px
                    resize: true, // defaults to true, set false if you do not want to resize the image width and height
                }).then(async (data) => {
                    var imgSrc = data[0].prefix + data[0].data;
                    var rotationDegrees = 0;
                    switch(orientation) {
                        case 3:
                            rotationDegrees = 180;
                            break;
                        case 6:
                            rotationDegrees = -90;
                            break;
                        case 8:
                            rotationDegrees = 90;
                            break;    
                    }

                    if(rotationDegrees != 0) {
                        await this.rotateImage(imgSrc, rotationDegrees).then(newDataUri => {
                            console.log('Image rotated');
                            imgSrc = newDataUri;
                        }).catch(e => {
                            console.log(e);
                        });
                    }

                    console.log('Image added to array');
                    this.door.offline_images.push({
                        'data': imgSrc, 
                        'alt': data[0].alt, 
                        'orientation': orientation, 
                        'offline_image_id': this.$session.get('user_id').toString() + Math.floor(new Date().getTime() / 1000)
                    });
                    this.isImageUploading = false;
                });
            },
            getDeclaredResistanceLevels() {
                var vmt = this;
                this.getDb(function onConnectedDb(db) {

                    var vm = vmt;
                    vm.declaredResistanceLevels = [];
                    try {
                        var objectStore = db.transaction('declared_resistance_levels').objectStore('declared_resistance_levels');
                        if (objectStore) {
                            objectStore.openCursor().onsuccess = function (event) {
                                var cursor = event.target.result;

                                if (cursor) {
                                    if (vm.declaredResistanceLevels) {
                                        vm.declaredResistanceLevels.push({
                                            declared_resistance_level_id: cursor.value.declared_resistance_level_id,
                                            declared_resistance_level_title: cursor.value.declared_resistance_level_title,
                                        })
                                    }
                                    cursor.continue();
                                }
                            };
                        }
                    } catch (e) {
                        console.log(e);
                    }
                })
            },
            getDoor() {
                var vm = this;
                this.getDb(function onConnectedDb(db) {
                    try {
                        var itemId = parseInt(vm.$route.params.id);
                        var objectStore = db.transaction('door_maintenance_report_items').objectStore('door_maintenance_report_items');
                        var storeRequest = objectStore.get(itemId);
                        storeRequest.onsuccess = function(event) {
                            vm.door = storeRequest.result;
                            if (storeRequest.result !== undefined) {
                                vm.getReport();
                            }
                        };
                        storeRequest.onerror = function(e) {
                            console.log(e);
                        }
                    } catch (e) {
                        console.log(e);
                    }
                });
            },
            getReport() {
                var vm = this;
                this.getDb(function onConnectedDb(db) {
                    try {
                        var reportId = vm.isEdit ? vm.door.site_door_maintenance_report_id : parseInt(vm.$route.params.id);
                        var objectStore = db.transaction('door_maintenance_reports').objectStore('door_maintenance_reports');
                        var storeRequest = objectStore.get(reportId);
                        storeRequest.onsuccess = function(event) {
                            vm.report = storeRequest.result;
                            if (storeRequest.result !== undefined) {
                                vm.door.site_door_maintenance_report_id = vm.report.site_door_maintenance_report_id;
                                vm.door.door_maintenance_report_id = vm.report.door_maintenance_report_id;
                            }
                        };
                        storeRequest.onerror = function(e) {
                            console.log(e);
                        }
                    } catch (e) {
                        console.log(e);
                    }
                })
            },
            submit() {
                this.$v.$touch();
                if (!this.$v.$error) {
                    this.sendFormData();
                } else {
                    this.validationError();
                }
            },
            enableSubmitLoader() {
                this.submitting = true;
            },
            disableSubmitLoader() {
                this.submitting = false;
            },
            sendFormData() {
                this.enableSubmitLoader();

                var vmt = this;
                this.getDb(function onConnectedDb(db) {

                    var putRequest = db.transaction('door_maintenance_report_items', 'readwrite')
                        .objectStore('door_maintenance_report_items').put({
                            door_maintenance_report_item_id: vmt.door['door_maintenance_report_item_id'],
                            site_door_maintenance_report_item_id: vmt.door['site_door_maintenance_report_item_id'],
                            site_door_maintenance_report_id: vmt.door['site_door_maintenance_report_id'],
                            door_maintenance_report_id: vmt.door['door_maintenance_report_id'],
                            door_identifier: vmt.door['door_identifier'],
                            door_location: vmt.door['door_location'],
                            declared_fire_resistance_period: vmt.door['declared_fire_resistance_period'],
                            maintenance_date: vmt.door['maintenance_date'],
                            maintained_by: vmt.door['maintained_by'],
                            maintenance_label_fitted: vmt.door['maintenance_label_fitted'],
                            is_installer_plug_label_fitted: vmt.door['is_installer_plug_label_fitted'],
                            maintenance_guidance_used: vmt.door['maintenance_guidance_used'],
                            comments: vmt.door['comments'],
                            user_id: vmt.$session.get('user_id'),
                            door_maintenance_report_item_images: vmt.door['door_maintenance_report_item_images'],
                            offline_images: vmt.door['offline_images']
                        });
                    putRequest.onsuccess = function(event) {
                        vmt.submitSuccess({
                            success: true,
                            site_door_maintenance_report_item_id: putRequest.result,
                        })
                    }
                    putRequest.onerror = function(event) {
                        alert("Unable to add data ");
                    };
                })

            },
            submitSuccess(response) {
                if (response.success) {
                    this.isSubmitted = true;
                    this.isError = false;
                    this.$router.push({ name: 'door-maintenance-report-view-item', params: {id: response.site_door_maintenance_report_item_id} })
                } else {
                    this.errorHeader = 'error.invalidFields';
                    this.errors = response.data.errors;
                    this.isError = true;
                }
            },
            submitError(error) {
                this.errorHeader = 'error.general';
                this.errors = [{'field': null, 'message': 'error.generalMessage'}];
                this.isError = true;
            },
            validationError() {
                this.errorHeader = 'error.invalidFields';
                this.errors = this.getErrors();
                this.isError = true;
            },
            isErrorField(field) {
                try {
                    if (this.getValidationField(field).$error) {
                        return true;
                    }
                } catch (error) {}

                return this.errors.some(el => el.field === field);
            },
            getErrors() {
                let errors = [];
                for (var field of Object.keys(this.door)) {
                    try {
                        if (this.getValidationField(field).$error) {
                            errors.push({'field': field, 'message': null});
                        }
                    } catch (error) {}
                }
                return errors;
            },
            getFieldClasses(field) {
                return { 'is-invalid': this.isErrorField(field) }
            },
            getContainerClasses(field) {
                return { 'text-danger': this.isErrorField(field) }
            },
            getValidationField(field) {
                if (this.$v.door[field]) {
                    return this.$v.door[field];
                }
                throw Error('No validation for field ' + field);
            },
            onFieldBlur(field) {
                try {
                    this.getValidationField(field).$touch();
                    if (this.getValidationField(field).$error) {
                        if (!this.errors.some(el => el.field === field)) {
                            this.errors.push({'field': field, 'message': null});
                        }
                    } else {
                        this.errors = this.errors.filter(el => el.field !== field);
                    }
                } catch (error) {}
            },
        },
        mounted () {
            const modulesData = this.$session.get('enabled_modules');
            if(!modulesData || modulesData.indexOf('FDIR') === -1) {
                this.$router.push('/');
                return;
            }
            
            this.getDeclaredResistanceLevels();

            if (this.$route.name === 'door-maintenance-report-edit-item') {
                this.isEdit = true;
            }
            
            if (!this.isEdit) {
                this.getReport();
            } else {
                this.getDoor();
            }
        }
    }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
    form {
        margin-bottom: 2rem;
    }

    [class*='-message'] {
        font-weight: 500;
    }

    .has-error {
        border: 1px solid #d33c40;
    }

    .error-message {
        color: #d33c40;
    }

    .success-message {
        color: #32a95d;
    }

    .form-control {
        background: #fff !important;
    }
    .vdp-datepicker__calendar .selected {
        background: var(--primary-color) !important;
        color: #fff;
    }
    .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).day:hover,
    .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).month:hover,
    .vdp-datepicker__calendar .cell:not(.blank):not(.disabled).year:hover {
        border: 1px solid var(--primary-color) !important;
    }
</style>